import React from 'react';
import styled from '@emotion/styled';

import { BadgeList } from '../components/Badge/BadgeList';
import { PromotionLayout } from '../components/PromotionLayout';
import { useProductMetadata } from '../hooks/useProductMetadata';
import { usePromotionTimerService } from '../services/usePromotionTimerService';
import { CouponContainer } from './CouponContainer';
import { CreatorCouponContainer } from './CreatorCouponContainer';
import { PriceContainer } from './PriceContainer';

export interface ProductMetadataContainerProps {}

export const ProductMetadataContainer: React.FC<React.PropsWithChildren<ProductMetadataContainerProps>> = () => {
  const {
    below_atf_price_badge_list,
    floatBannerInfo,
    displayPriceLine,
    hasBadge,
    shouldShowPromotionLayout,
    impressionPromotionBannerRef,
    handleHeaderClick,
  } = useProductMetadata();
  const timestamp = floatBannerInfo?.end_time ?? 0;
  const { getFormattedCountdown, isTimerActive } = usePromotionTimerService({
    timestamp,
    onExpire: undefined,
  });

  const content = (
    <Container displayPriceLine={displayPriceLine}>
      <div>
        <PriceContainer />
        {hasBadge && <BadgeList badgeList={below_atf_price_badge_list} />}
      </div>
      <MetaDataCoupon className='metadata-coupon'>
        <CouponContainer />
      </MetaDataCoupon>

      <CreatorCouponContainer />
    </Container>
  );

  if (!shouldShowPromotionLayout || !isTimerActive()) {
    return <DefaultLayout>{content}</DefaultLayout>;
  }

  return (
    <PromotionLayout
      ref={impressionPromotionBannerRef}
      bannerInfo={floatBannerInfo}
      countdown={getFormattedCountdown()}
      onHeaderClick={handleHeaderClick}
    >
      {content}
    </PromotionLayout>
  );
};

const DefaultLayout = styled.div`
  margin-top: 8px;
  padding: 16px;
`;

const Container = styled.div<{ displayPriceLine: number }>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  ${({ displayPriceLine }) => {
    if (displayPriceLine === 3) {
      return `
        .metadata-coupon {
          padding: 10px 0 0 0;
        }
      `;
    }
  }}
`;

const MetaDataCoupon = styled.div`
  margin: 0 0 0 4px;
`;
